import { FaqItemEffect } from './faq-item.effect';
import { FaqOverviewSearchEffect } from './faq-overview-search.effect';
import { FaqOverviewEffect } from './faq-overview.effect';

export const effects: any[] = [
  FaqItemEffect,
  FaqOverviewEffect,
  FaqOverviewSearchEffect,
];
